import React from "react";
import { Button } from "@mui/material";

const SubscribeButton = () => {
  return (

      <Button
        fullWidth
        sx={{
          bgcolor: "#f3d45e",
          color: "#000",
          borderRadius: "48px",
          minHeight: 50,
          textTransform: "none",
          fontFamily: "Inter700",
          fontWeight: 600,
          fontSize: 17,
          "&:hover": {
            bgcolor: "#f3d45e",
          },
        }}
      >
        Subscribe
      </Button>

  );
};

export default SubscribeButton;
